import {
  call, put, select,
} from 'redux-saga/effects';
import { selectAppName, selectUserId } from '../../../state/configs/configsSlice';
import { selectContacts, setFilteredBy } from '../../../state/contacts/contactsSlice';
import processResultSet from '../processResultSet/processResultSet';
import processSearchResultSet from '../processSearchResultSet/processSearchResultSet';

export default function* contactsFilteredBy({ payload: filterBy }) {
  const appName = yield select(selectAppName);
  const userId = yield select(selectUserId);

  localStorage.setItem(
    `${appName}-${userId}_contacts-filter-by`,
    filterBy,
  );

  yield put(setFilteredBy(filterBy));

  const contacts = yield select(selectContacts);

  if (contacts) {
    yield call(processResultSet);
    yield call(processSearchResultSet);
  }
}
